import { onReady } from "../base/common.js";

// ヘッダー状態（is-top / is-scrolled）と、スクロール方向での表示/非表示
onReady(() => {
    const header = document.querySelector(".l-header");
    if (!header) return;
    let forceShowTimer = null;

    const enableForceShow = (duration = 800) => {
        header.classList.remove("is-hide");
        header.dataset.forceShow = "true";
        if (forceShowTimer) clearTimeout(forceShowTimer);
        forceShowTimer = window.setTimeout(() => {
            delete header.dataset.forceShow;
            forceShowTimer = null;
        }, duration);
    };

    // --- is-top / is-scrolled（ヘッダー高さ分を考慮） ---
    // DOM を変更する前に高さを読み、強制的な再レイアウトを避ける。
    const headerH = header.offsetHeight || 64;
    const sentinel = document.createElement("div");
    sentinel.style.position = "absolute";
    sentinel.style.inset = "0 auto auto 0";
    sentinel.style.height = "1px";
    // 先頭に置く
    document.body.prepend(sentinel);

    const io = new IntersectionObserver(
        ([e]) => {
            header.classList.toggle("is-top", e.isIntersecting);
            header.classList.toggle("is-scrolled", !e.isIntersecting);

            // トップに戻ったら必ず表示
            if (e.isIntersecting) header.classList.remove("is-hide");
        },
        // ビューポートの上端をヘッダー高さ分「上」にずらす（＝少しでも下に動いたら is-scrolled）
        { threshold: 0, rootMargin: `-${headerH + 1}px 0px 0px 0px` }
    );
    io.observe(sentinel);

    // --- スクロール方向でヘッダー表示/非表示（メニュー開時は停止） ---
    const gnav = document.getElementById("globalnav");
    let last = 0;
    const threshold = 10;
    const isForceShowing = () => header.dataset.forceShow === "true";

    const getScrollY = () => Math.max(0, window.scrollY || window.pageYOffset || 0); // iOSの負値を0に丸め

    const onScroll = () => {
        if (gnav && gnav.classList.contains("is-open")) return;

        const cur = getScrollY();

        if (isForceShowing()) {
            header.classList.remove("is-hide");
            last = cur;
            return;
        }

        // トップ近傍では必ず表示（IO発火しない端末対策）
        if (cur <= 1) {
            header.classList.remove("is-hide");
            last = 0;
            return;
        }

        // 一定以上動いた時だけトグル
        if (Math.abs(cur - last) > threshold) {
            const goingDown = cur > last;
            header.classList.toggle("is-hide", goingDown);
            last = cur;
        }
    };

    window.addEventListener("scroll", onScroll, { passive: true });

    // スクロール終了時にも最終状態を補正（Safariでの取りこぼし対策）
    window.addEventListener?.("scrollend", () => {
        if (getScrollY() <= 1) header.classList.remove("is-hide");
    });

    document.addEventListener("header:force-show", (event) => {
        const duration = event?.detail?.duration;
        enableForceShow(typeof duration === "number" ? duration : undefined);
    });
});
